/* tslint:disable */
/* eslint-disable */
/* @relayHash f0816631a6ba61265912a3b1a14a3050 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type SectionFilter = {
    name?: string | null;
};
export type ApprovedQueueRouteQueryVariables = {
    storyID?: string | null;
    siteID?: string | null;
    section?: SectionFilter | null;
    initialOrderBy?: COMMENT_SORT | null;
};
export type ApprovedQueueRouteQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"ApprovedQueueRoute_query">;
};
export type ApprovedQueueRouteQuery = {
    readonly response: ApprovedQueueRouteQueryResponse;
    readonly variables: ApprovedQueueRouteQueryVariables;
};



/*
query ApprovedQueueRouteQuery(
  $storyID: ID
  $siteID: ID
  $section: SectionFilter
  $initialOrderBy: COMMENT_SORT
) {
  ...ApprovedQueueRoute_query_28QY37
}

fragment ApprovedQueueRoute_query_28QY37 on Query {
  comments(status: APPROVED, storyID: $storyID, siteID: $siteID, section: $section, first: 5, orderBy: $initialOrderBy) {
    edges {
      node {
        id
        site {
          id
        }
        author {
          id
        }
        ...ModerateCardContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  settings {
    ...ModerateCardContainer_settings
    id
  }
  viewer {
    ...ModerateCardContainer_viewer
    id
  }
}

fragment AutomatedActionsContainer_comment on Comment {
  revision {
    metadata {
      perspective {
        score
      }
      externalModeration {
        name
        analyzedAt
        result {
          status
          tags
          actions {
            reason
          }
        }
      }
    }
    id
  }
}

fragment AutomatedActionsContainer_settings on Settings {
  integrations {
    perspective {
      threshold
    }
    external {
      phases {
        name
        id
      }
    }
  }
}

fragment CommentAuthorContainer_comment on Comment {
  author {
    id
    username
    status {
      suspension {
        active
      }
      premod {
        active
      }
      ban {
        active
      }
    }
  }
}

fragment CommentRevisionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    id
  }
  revisionHistory {
    id
    body
    createdAt
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
        title
        width
        height
        tenorStill: still
        tenorVideo: video
      }
      ... on TwitterMedia {
        url
      }
      ... on YouTubeMedia {
        url
        still
        title
      }
      ... on ExternalMedia {
        url
      }
    }
  }
}

fragment DecisionDetailsContainer_comment on Comment {
  id
  statusHistory(first: 1) {
    edges {
      node {
        createdAt
        rejectionReason {
          code
          legalGrounds
          detailedExplanation
          customReason
        }
        id
      }
    }
  }
}

fragment FlagDetailsContainer_comment on Comment {
  flags {
    nodes {
      flagger {
        username
        id
      }
      reason
      additionalDetails
      id
    }
  }
  illegalContent {
    nodes {
      flagger {
        username
        id
      }
      additionalDetails
      reportID
      id
    }
  }
  revision {
    metadata {
      perspective {
        score
      }
    }
    id
  }
}

fragment LinkDetailsContainer_comment on Comment {
  id
  story {
    id
    url
  }
}

fragment LinkDetailsContainer_settings on Settings {
  organization {
    url
  }
}

fragment MarkersContainer_comment on Comment {
  ...ModerateCardDetailsContainer_comment
  initialStatus
  status
  tags {
    code
  }
  author {
    premoderatedBecauseOfEmailAt
    id
  }
  revision {
    actionCounts {
      illegal {
        total
      }
      flag {
        reasons {
          COMMENT_REPORTED_SPAM
          COMMENT_REPORTED_OTHER
          COMMENT_REPORTED_OFFENSIVE
          COMMENT_REPORTED_ABUSIVE
          COMMENT_REPORTED_BIO
          COMMENT_DETECTED_TOXIC
          COMMENT_DETECTED_SUSPECT_WORD
          COMMENT_DETECTED_SPAM
          COMMENT_DETECTED_REPEAT_POST
          COMMENT_DETECTED_RECENT_HISTORY
          COMMENT_DETECTED_NEW_COMMENTER
          COMMENT_DETECTED_LINKS
          COMMENT_DETECTED_BANNED_WORD
        }
      }
    }
    metadata {
      wordList {
        timedOut
      }
      externalModeration {
        name
        analyzedAt
        result {
          status
          tags
          actions {
            reason
          }
        }
      }
    }
    id
  }
}

fragment MarkersContainer_settings on Settings {
  ...ModerateCardDetailsContainer_settings
}

fragment MediaContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
        title
        width
        height
        tenorStill: still
        tenorVideo: video
      }
      ... on TwitterMedia {
        url
      }
      ... on YouTubeMedia {
        url
        still
        title
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment ModerateCardContainer_comment on Comment {
  id
  site {
    id
    name
  }
  author {
    id
    email
    username
    status {
      current
      ban {
        active
        sites {
          id
          name
        }
      }
    }
    role
  }
  createdAt
  body
  rating
  revision {
    actionCounts {
      flag {
        reasons {
          COMMENT_DETECTED_BANNED_WORD
          COMMENT_DETECTED_SUSPECT_WORD
        }
      }
    }
    metadata {
      wordList {
        bannedWords {
          value
          index
          length
        }
        suspectWords {
          value
          index
          length
        }
      }
    }
    id
  }
  tags {
    code
  }
  status
  editing {
    edited
  }
  parent {
    author {
      id
      username
    }
    id
  }
  canModerate
  story {
    id
    metadata {
      title
    }
    settings {
      mode
    }
    isArchived
    isArchiving
  }
  permalink
  deleted
  ...MarkersContainer_comment
  ...ModeratedByContainer_comment
  ...CommentAuthorContainer_comment
  ...MediaContainer_comment
}

fragment ModerateCardContainer_settings on Settings {
  protectedEmailDomains
  locale
  wordList {
    banned
    suspect
  }
  emailDomainModeration {
    domain
    newUserModeration
    id
  }
  multisite
  ...MarkersContainer_settings
}

fragment ModerateCardContainer_viewer on User {
  id
  role
  moderationScopes {
    scoped
    sites {
      id
      name
    }
  }
}

fragment ModerateCardDetailsContainer_comment on Comment {
  id
  status
  tags {
    code
  }
  editing {
    edited
  }
  statusHistory(first: 1) {
    edges {
      node {
        rejectionReason {
          code
        }
        id
      }
    }
  }
  revision {
    actionCounts {
      illegal {
        total
      }
      flag {
        reasons {
          COMMENT_REPORTED_OFFENSIVE
          COMMENT_REPORTED_ABUSIVE
          COMMENT_REPORTED_SPAM
          COMMENT_REPORTED_OTHER
          COMMENT_DETECTED_TOXIC
          COMMENT_DETECTED_SPAM
          COMMENT_REPORTED_BIO
        }
      }
      reaction {
        total
      }
    }
    metadata {
      perspective {
        score
      }
      externalModeration {
        name
        result {
          status
          tags
          actions {
            reason
          }
        }
      }
    }
    id
  }
  ...FlagDetailsContainer_comment
  ...CommentRevisionContainer_comment
  ...LinkDetailsContainer_comment
  ...AutomatedActionsContainer_comment
  ...DecisionDetailsContainer_comment
}

fragment ModerateCardDetailsContainer_settings on Settings {
  ...LinkDetailsContainer_settings
  ...AutomatedActionsContainer_settings
}

fragment ModeratedByContainer_comment on Comment {
  id
  status
  statusHistory(first: 1) {
    edges {
      node {
        status
        moderator {
          id
          username
        }
        id
      }
    }
  }
  revision {
    metadata {
      externalModeration {
        name
        result {
          status
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "initialOrderBy"
    } as any), v1 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "section"
    } as any), v2 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteID"
    } as any), v3 = ({
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "storyID"
    } as any), v4 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "initialOrderBy"
    } as any), v5 = ({
        "kind": "Variable",
        "name": "section",
        "variableName": "section"
    } as any), v6 = ({
        "kind": "Variable",
        "name": "siteID",
        "variableName": "siteID"
    } as any), v7 = ({
        "kind": "Variable",
        "name": "storyID",
        "variableName": "storyID"
    } as any), v8 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 5
        } as any),
        (v4 /*: any*/),
        (v5 /*: any*/),
        (v6 /*: any*/),
        ({
            "kind": "Literal",
            "name": "status",
            "value": "APPROVED"
        } as any),
        (v7 /*: any*/)
    ], v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any), v11 = [
        (v9 /*: any*/),
        (v10 /*: any*/)
    ], v12 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v13 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any), v14 = ({
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "sites",
        "plural": true,
        "selections": (v11 /*: any*/),
        "storageKey": null
    } as any), v15 = [
        (v13 /*: any*/)
    ], v16 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
    } as any), v19 = [
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
        } as any)
    ], v20 = [
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "index",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "length",
            "storageKey": null
        } as any)
    ], v21 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any), v22 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
    } as any), v23 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v24 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v25 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v26 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v27 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v28 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "still",
        "storageKey": null
    } as any), v29 = [
        (v24 /*: any*/)
    ], v30 = ({
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "media",
        "plural": false,
        "selections": [
            (v23 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v27 /*: any*/),
                    (v28 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "video",
                        "storageKey": null
                    }
                ],
                "type": "GiphyMedia",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    (v24 /*: any*/),
                    (v25 /*: any*/),
                    (v26 /*: any*/),
                    (v27 /*: any*/),
                    {
                        "alias": "tenorStill",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "still",
                        "storageKey": null
                    },
                    {
                        "alias": "tenorVideo",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "video",
                        "storageKey": null
                    }
                ],
                "type": "TenorMedia",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": (v29 /*: any*/),
                "type": "TwitterMedia",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    (v24 /*: any*/),
                    (v28 /*: any*/),
                    (v25 /*: any*/)
                ],
                "type": "YouTubeMedia",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": (v29 /*: any*/),
                "type": "ExternalMedia",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any), v31 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
    } as any), v32 = [
        (v9 /*: any*/),
        (v12 /*: any*/)
    ], v33 = ({
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "flagger",
        "plural": false,
        "selections": [
            (v12 /*: any*/),
            (v9 /*: any*/)
        ],
        "storageKey": null
    } as any), v34 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalDetails",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "ApprovedQueueRouteQuery",
            "selections": [
                {
                    "args": [
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        (v6 /*: any*/),
                        (v7 /*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "ApprovedQueueRoute_query"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v3 /*: any*/),
                (v2 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "ApprovedQueueRouteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v8 /*: any*/),
                    "concreteType": "CommentsConnection",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v9 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Site",
                                            "kind": "LinkedField",
                                            "name": "site",
                                            "plural": false,
                                            "selections": (v11 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "email",
                                                    "storageKey": null
                                                },
                                                (v12 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "UserStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "current",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "BanStatus",
                                                            "kind": "LinkedField",
                                                            "name": "ban",
                                                            "plural": false,
                                                            "selections": [
                                                                (v13 /*: any*/),
                                                                (v14 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SuspensionStatus",
                                                            "kind": "LinkedField",
                                                            "name": "suspension",
                                                            "plural": false,
                                                            "selections": (v15 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PremodStatus",
                                                            "kind": "LinkedField",
                                                            "name": "premod",
                                                            "plural": false,
                                                            "selections": (v15 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v16 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "premoderatedBecauseOfEmailAt",
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "commentsRejectedOnSites",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "allCommentsRejected",
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "rating",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentRevision",
                                            "kind": "LinkedField",
                                            "name": "revision",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ActionCounts",
                                                    "kind": "LinkedField",
                                                    "name": "actionCounts",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlagActionCounts",
                                                            "kind": "LinkedField",
                                                            "name": "flag",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "FlagReasonActionCounts",
                                                                    "kind": "LinkedField",
                                                                    "name": "reasons",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_DETECTED_BANNED_WORD",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_DETECTED_SUSPECT_WORD",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_REPORTED_OFFENSIVE",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_REPORTED_ABUSIVE",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_REPORTED_SPAM",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_REPORTED_OTHER",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_DETECTED_TOXIC",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_DETECTED_SPAM",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_REPORTED_BIO",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_DETECTED_REPEAT_POST",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_DETECTED_RECENT_HISTORY",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_DETECTED_NEW_COMMENTER",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "COMMENT_DETECTED_LINKS",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "IllegalActionCounts",
                                                            "kind": "LinkedField",
                                                            "name": "illegal",
                                                            "plural": false,
                                                            "selections": (v19 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ReactionActionCounts",
                                                            "kind": "LinkedField",
                                                            "name": "reaction",
                                                            "plural": false,
                                                            "selections": (v19 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentRevisionMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "metadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentRevisionWordListMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "wordList",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WordlistMatch",
                                                                    "kind": "LinkedField",
                                                                    "name": "bannedWords",
                                                                    "plural": true,
                                                                    "selections": (v20 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WordlistMatch",
                                                                    "kind": "LinkedField",
                                                                    "name": "suspectWords",
                                                                    "plural": true,
                                                                    "selections": (v20 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "timedOut",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentRevisionPerspectiveMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "perspective",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "score",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentRevisionExternalModerationPhaseMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "externalModeration",
                                                            "plural": true,
                                                            "selections": [
                                                                (v10 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ExternalModerationPhaseResult",
                                                                    "kind": "LinkedField",
                                                                    "name": "result",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v21 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "tags",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ExternalModerationPhaseAction",
                                                                            "kind": "LinkedField",
                                                                            "name": "actions",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v22 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "analyzedAt",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/),
                                                (v30 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Tag",
                                            "kind": "LinkedField",
                                            "name": "tags",
                                            "plural": true,
                                            "selections": [
                                                (v31 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v21 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EditInfo",
                                            "kind": "LinkedField",
                                            "name": "editing",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "edited",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "author",
                                                    "plural": false,
                                                    "selections": (v32 /*: any*/),
                                                    "storageKey": null
                                                },
                                                (v9 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "canModerate",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Story",
                                            "kind": "LinkedField",
                                            "name": "story",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "StoryMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "metadata",
                                                    "plural": false,
                                                    "selections": [
                                                        (v25 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "StorySettings",
                                                    "kind": "LinkedField",
                                                    "name": "settings",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "mode",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isArchived",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isArchiving",
                                                    "storageKey": null
                                                },
                                                (v24 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "permalink",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "deleted",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1
                                                }
                                            ],
                                            "concreteType": "CommentModerationActionConnection",
                                            "kind": "LinkedField",
                                            "name": "statusHistory",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentModerationActionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CommentModerationAction",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "RejectionReason",
                                                                    "kind": "LinkedField",
                                                                    "name": "rejectionReason",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v31 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "legalGrounds",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "detailedExplanation",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "customReason",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v9 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v21 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "moderator",
                                                                    "plural": false,
                                                                    "selections": (v32 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "statusHistory(first:1)"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlagsConnection",
                                            "kind": "LinkedField",
                                            "name": "flags",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Flag",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        (v33 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v9 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlagsConnection",
                                            "kind": "LinkedField",
                                            "name": "illegalContent",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Flag",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        (v33 /*: any*/),
                                                        (v34 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "reportID",
                                                            "storageKey": null
                                                        },
                                                        (v9 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CommentRevision",
                                            "kind": "LinkedField",
                                            "name": "revisionHistory",
                                            "plural": true,
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v18 /*: any*/),
                                                (v17 /*: any*/),
                                                (v30 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "initialStatus",
                                            "storageKey": null
                                        },
                                        (v23 /*: any*/),
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "viewerDidModerate",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "statusLiveUpdated",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "enteredLive",
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v8 /*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "ApprovedQueue_comments",
                    "kind": "LinkedHandle",
                    "name": "comments"
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "protectedEmailDomains",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "locale",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordList",
                            "kind": "LinkedField",
                            "name": "wordList",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "banned",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "suspect",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmailDomain",
                            "kind": "LinkedField",
                            "name": "emailDomainModeration",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "domain",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "newUserModeration",
                                    "storageKey": null
                                },
                                (v9 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "multisite",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": (v29 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalIntegrations",
                            "kind": "LinkedField",
                            "name": "integrations",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PerspectiveExternalIntegration",
                                    "kind": "LinkedField",
                                    "name": "perspective",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "threshold",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CustomExternalIntegration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExternalModerationPhase",
                                            "kind": "LinkedField",
                                            "name": "phases",
                                            "plural": true,
                                            "selections": [
                                                (v10 /*: any*/),
                                                (v9 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v9 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v9 /*: any*/),
                        (v16 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserModerationScopes",
                            "kind": "LinkedField",
                            "name": "moderationScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scoped",
                                    "storageKey": null
                                },
                                (v14 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "f0816631a6ba61265912a3b1a14a3050",
            "metadata": {},
            "name": "ApprovedQueueRouteQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'aad7a243e632a9cb1b693e8774f20c63';
export default node;
